import { render, staticRenderFns } from "./SpaceAttachExternalStorageDialog.vue?vue&type=template&id=7ace19cc&"
import script from "./SpaceAttachExternalStorageDialog.vue?vue&type=script&lang=js&"
export * from "./SpaceAttachExternalStorageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports